import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var createIsIdentityExpiredFunction = function createIsIdentityExpiredFunction(expirationMs) {
  return function (identity) {
    return doesIdentityRequireRefresh(identity) && identity.expiration.getTime() - Date.now() < expirationMs;
  };
};
export var EXPIRATION_MS = 300000;
export var isIdentityExpired = createIsIdentityExpiredFunction(EXPIRATION_MS);
export var doesIdentityRequireRefresh = function doesIdentityRequireRefresh(identity) {
  return identity.expiration !== undefined;
};
export var memoizeIdentityProvider = function memoizeIdentityProvider(provider, isExpired, requiresRefresh) {
  if (provider === undefined) {
    return undefined;
  }
  var normalizedProvider = typeof provider !== "function" ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Promise.resolve(provider));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })) : provider;
  var resolved;
  var pending;
  var hasResult;
  var isConstant = false;
  var coalesceProvider = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!pending) {
                pending = normalizedProvider(options);
              }
              _context2.prev = 1;
              _context2.next = 4;
              return pending;
            case 4:
              resolved = _context2.sent;
              hasResult = true;
              isConstant = false;
            case 7:
              _context2.prev = 7;
              pending = undefined;
              return _context2.finish(7);
            case 10:
              return _context2.abrupt("return", resolved);
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1,, 7, 10]]);
    }));
    return function coalesceProvider(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (isExpired === undefined) {
    return /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(options) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!hasResult || options !== null && options !== void 0 && options.forceRefresh)) {
                  _context3.next = 4;
                  break;
                }
                _context3.next = 3;
                return coalesceProvider(options);
              case 3:
                resolved = _context3.sent;
              case 4:
                return _context3.abrupt("return", resolved);
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  }
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(options) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!hasResult || options !== null && options !== void 0 && options.forceRefresh)) {
                _context4.next = 4;
                break;
              }
              _context4.next = 3;
              return coalesceProvider(options);
            case 3:
              resolved = _context4.sent;
            case 4:
              if (!isConstant) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return", resolved);
            case 6:
              if (requiresRefresh(resolved)) {
                _context4.next = 9;
                break;
              }
              isConstant = true;
              return _context4.abrupt("return", resolved);
            case 9:
              if (!isExpired(resolved)) {
                _context4.next = 13;
                break;
              }
              _context4.next = 12;
              return coalesceProvider(options);
            case 12:
              return _context4.abrupt("return", resolved);
            case 13:
              return _context4.abrupt("return", resolved);
            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};